import { Alerts, Brand, Neutrals, Theme } from './colors';

export const Icon = {
  IconColorPrimary: Neutrals.neutralGreys.GreyNatural900,
  IconColorSecondary: Neutrals.neutralGreys.GreyNatural700,
  IconColorTertiary: Neutrals.neutralGreys.GreyNatural600,
  IconColorPlaceholder: Neutrals.neutralGreys.GreyNatural400,
  IconColorInteractive: Theme.main.ThemeWater,
  IconColorBrand: Brand.water.Water500,
  IconColorPromo: Brand.orange.Orange500,
  IconColorDelivery: Brand.iris.Iris500,
  IconColorSuccess: Alerts.Green500,
  IconColorAlert: Alerts.Yellow500,
  IconColorError: Alerts.Red500,
  IconColorDisabled: Neutrals.neutralGreys.GreyNatural300,
  IconColorOnDark: Neutrals.main.White,
  IconColorInverted: Neutrals.main.White,
};
